selectPlanByPlanId